<template>
  <div>
    <div
      class="h-100 click py-2"
      v-if="p._id"
      @click="view()"
      style="min-width: 160px; max-width: 100%; width: 100%"
    >
      <div class="border single-product-card">
        <b-img-lazy
          class="img-fluid w-100"
          :src="getImage(p.image, 'small')"
        ></b-img-lazy>
      </div>

      <div class="px-2 py-1 position-relative">
        <div
          class="badge badge-info rounded-0 py-2 position-absolute px-3 promo-badge"
          style="top: -90px; left: 0px"
          v-if="getPromoSummary(p)"
        >
          <span style="font-size: 12px"> {{ getPromoSummary(p) }} </span>
          <span class="d-none promo-detail">{{ getPromo(p.value, p.promos) }}</span>
        </div>
        <div
          class="badge rounded-0 py-2 position-absolute px-3 availability-badge"
          style="top: -90px; right: 0px"
          v-if="hasExclusiveAvailability"
        >
          <span style="font-size: 12px">{{ getAvailable(p.available_on) }}</span>
        </div>
        <div
          class="badge badge-warning rounded-0 py-2 position-absolute w-100 category-badge"
          style="top: -120px; left: 0px"
          v-if="p.stock !== false && p.stock < 1"
        >
          <span style="font-size: 12px"> SIN STOCK </span>
        </div>
        <div
          class="badge badge-secondary rounded-0 position-absolute px-3"
          style="top: -40px; left: 0px"
        >
          <span style="font-size: 12px">
            {{ (p.category && p.category.name) || "Sin Categoria" }}
          </span>
        </div>
        <div
          class="badge badge-danger rounded-0 position-absolute product-price-badge"
          style="top: -20px; right: 0px"
        >
          <small
            class="d-block text-secondary px-2 pt-1"
            v-if="getCardDiscountedPrice(p) < p.value"
          >
            <s>${{ formatNumber(p.value) }}</s>
          </small>
          <span style="font-size: 12px" class="d-block px-2 pb-1">
            ${{ formatNumber(getCardDiscountedPrice(p)) }}
          </span>
        </div>
        <div class="overflow-hidden pt-2">
          <span
            class="card-title text-uppercase font-weight-bold pr-2 product-title"
          >
            {{ p.name }}
          </span>
        </div>
      </div>
      <div class="align-self-end w-100 px-2 mb-2 d-none">
        <div class="row">
          <div class="col-md-5 ml-auto">
            <router-link
              class="btn btn-outline-success text-center d-block btn-sm"
              :to="getLink(`producto/${p._id}`)"
            >
              <b-icon icon="cart" />
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data", "id"],
  data() {
    return {
      p: {},
    };
  },
  computed: {
    hasExclusiveAvailability() {
      return !!(
        this.p &&
        this.p.available_on &&
        this.getAvailable(this.p.available_on)
      );
    },
  },
  mounted() {
    if (!this.data) this.load();
    else this.p = this.data;
  },
  methods: {
    isPromoActiveForQty(promo = {}, qty = 1) {
      if (!promo || !promo.enabled) return false;
      if (promo.when == "qty") return this.checkCondition(qty, promo.is, promo.value);
      if (!promo.when) return true;
      return promo.when != "total" && promo.when != "minopcion";
    },
    getPromoSummary(product = {}) {
      const promos = (product.promos || []).filter((promo) => promo && promo.enabled);
      if (promos.length === 0) return "";

      const [promo] = promos;
      if (promo.to == "product") {
        if (promo.when == "qty" && Number(promo.value) > 1) {
          if (promo.in == "%") return `${promo.discount}% dcto desde ${promo.value} un.`;
          return `-$${this.formatNumber(promo.discount)} desde ${promo.value} un.`;
        }

        if (promo.in == "%") {
          return `Ahora $${this.formatNumber(product.value - (product.value * promo.discount) / 100)}`;
        }

        return `Ahora $${this.formatNumber(product.value - promo.discount)}`;
      }
      if (promo.to == "total" && promo.when == "qty") {
        if (promo.in == "%") return `${promo.discount}% dcto desde ${promo.value} un.`;
        if (promo.in == "$") return `-$${this.formatNumber(promo.discount)} desde ${promo.value} un.`;
      }
      if (promo.to == "total" && promo.when == "total") {
        if (promo.in == "%") return `${promo.discount}% dcto sobre $${this.formatNumber(promo.value)}`;
        if (promo.in == "$") return `-$${this.formatNumber(promo.discount)} sobre $${this.formatNumber(promo.value)}`;
      }
      if (promo.to == "option") {
        if (promo.in == "%" && Number(promo.discount) === 100) {
          return promo.value
            ? `Extra gratis desde $${this.formatNumber(promo.value)}`
            : "Extra gratis";
        }
        return promo.when == "minopcion" && promo.value
          ? `${promo.in == "%" ? promo.discount + "%" : "-$" + this.formatNumber(promo.discount)} en extras`
          : `${promo.in == "%" ? promo.discount + "%" : "-$" + this.formatNumber(promo.discount)} en opciones`;
      }
      return "Oferta";
    },
    getCardDiscountedPrice(product = {}) {
      const promos = Array.isArray(product.promos)
        ? product.promos.filter((promo) => promo && promo.enabled)
        : [];
      const baseValue = Number(product.value) || 0;
      const promo = promos.find((item) => item && item.enabled);

      if (!promo) return baseValue;
      if (!this.isPromoActiveForQty(promo, 1)) return baseValue;

      if (promo.to == "product") {
        if (promo.in == "%") {
          return Math.max(
            baseValue - baseValue * ((Number(promo.discount) || 0) / 100),
            0
          );
        }

        return Math.max(baseValue - (Number(promo.discount) || 0), 0);
      }

      if (
        promo.to == "total" &&
        promo.when == "qty" &&
        Number(promo.value) <= 1
      ) {
        if (promo.in == "%") {
          return Math.max(
            baseValue - baseValue * ((Number(promo.discount) || 0) / 100),
            0
          );
        }

        if (promo.in == "$") {
          return Math.max(baseValue - (Number(promo.discount) || 0), 0);
        }
      }

      return baseValue;
    },
    getAvailable(values) {
      let rs = "";

      if (values.length == 1) {
        const [value] = values;
        if (value == "pickup") rs = "Solo retiro";
        if (value == "delivery") rs = "Solo Delivery";
        if (value == "shipping") rs = "Solo Envio";
      } 
      //else {
      //   values.forEach((value) => {
      //     if (value == "pickup") rs += "Retiro";
      //     if (value == "delivery") rs += "Relivery";
      //     if (value == "shipping") rs += "Envio";
      //   });
      // }

      return rs;
    },
    getPromo(value = 0, promos) {
      let rs = "";

      promos.forEach((promo) => {
        if (!promo.enabled) return;
        if (promo.to == "product") {
          const targetPrice = promo.in == "%"
            ? Math.max(value - value * ((Number(promo.discount) || 0) / 100), 0)
            : Math.max(value - (Number(promo.discount) || 0), 0);
          if (promo.when == "qty" && Number(promo.value) > 1) {
            rs += `${promo.in == "%" ? promo.discount + "%" : "-$" + this.formatNumber(promo.discount)} desde ${promo.value} un.` + " \n";
          } else {
            rs += `$${this.formatNumber(targetPrice)} sobre $${this.formatNumber(value)}` + " \n";
          }
        }
        if (promo.to == "total")
          rs += `-$${promo.discount} al total sobre $${promo.value}` + " \n";
        if (promo.to == "option")
          rs += (
            promo.when == "minopcion" && promo.value
              ? `${promo.in == "$" ? "-$" : ""}${promo.discount}${
                  promo.in == "%" ? "%" : ""
                } en extras desde $${this.formatNumber(promo.value)}`
              : `${promo.in == "$" ? "-$" : ""}${promo.discount}${
                  promo.in == "%" ? "%" : ""
                } en opciones extra`
          ) + " \n";
        // console.log({ promo });
      });
      return rs;
    },
    view() {
      console.log("uwu");
      // push query pid
      this.$router.push({
        query: { pid: this.p._id },
      });
    },
    load() {
      const pid = this.id;
      const { webName: _id } = this.$store.state.info;
      this.$http
        .get(`${_id}/product/${pid}`)
        .then((res) => {
          this.p = res.data.data;
          //this.$store.commit("setProduct", res.data.data);
          console.log(res.data.data);
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
.single-product-card {
  max-width: 360px;
  margin: 0 auto;
}

.availability-badge {
  background: #bfdbfe;
  color: #1e3a8a;
  border: 1px solid rgba(59, 130, 246, 0.22);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
  max-width: 140px;
  white-space: normal;
  text-align: center;
  z-index: 3;
}

.product-price-badge {
  z-index: 4;
  min-width: 96px;
  text-align: center;
}

.product-title {
  display: block;
  line-height: 1.15;
  font-size: 1.05rem;
}

@media (max-width: 991.98px) {
  .single-product-card {
    max-width: 100%;
  }
}

@media (max-width: 575.98px) {
  .promo-badge,
  .availability-badge,
  .category-badge,
  .product-price-badge {
    position: static !important;
    display: inline-flex;
    width: auto !important;
    margin: 0.25rem 0.35rem 0.1rem 0;
  }

  .product-price-badge {
    justify-content: center;
    min-width: 120px;
  }

  .product-title {
    margin-top: 0.35rem;
    font-size: 1rem;
    line-height: 1.1;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
</style>
